export class Appointment {
    constructor(public data?: {
        TimeScheduled?: String,
        AppointmentSource?: Number,
        AppointmentStatus?: Number,
        PhonebookID?: Number,
        CallcenterAgent?: String,
        UserID?: Number,
        Latitude?: Number,
        Longitude?: Number,
        Comment?: String,
        Visible?: Boolean,
        Contact?: Object
        ContactID?: Object
    }) { }
}